import './CartPage.scss';

import { b2x } from '@b2x/react/src';

import { Container } from '../Container';
import { t } from '../i18n/i18n';
import { Page } from './Page';

export type CartPageProps = b2x.CartPageProps;

export const CartPage = (props: CartPageProps) => {
  return (
    <Page grayBackground>
      <section className="mb-5">
        <Container>
          <div className="text-center">
            <h1 className="text-uppercase m-0">{t('cart.title')}</h1>
          </div>
        </Container>
      </section>
      <div className="cart-page">
        <b2x.CartPage {...props} />
      </div>
    </Page>
  );
};
